import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect, useHistory, useRouteMatch, useLocation } from "react-router-dom";
import { connect, useSelector } from 'react-redux'

import WidgetContainer from "./WidgetContainer";
// import WidgetPreview from "./WidgetPreview";
import CreateWidget from './CreateWidget';
import { Widget } from './WidgetCard'
import { Http } from '../../../helpers/axois'
import { useToast } from '../../../helpers/commonFunction';
import { logger } from "../../../constant/winston";

import { ReactComponent as Filter } from "../../../assets/svg/filterSvg.svg";
import { ReactComponent as PlusIcon } from "../../../assets/svg/plus_btn.svg";
import { ReactComponent as SearchIcon } from "../../../assets/svg/searchIconWithBg.svg";
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
import './styles/widgets.scss'
import { PreviewSidebar } from "./widgetPreview/PreviewSidebar";
import NoData from "../../apps/NoData";
import { AppState } from "../../../stateManager/store";

const Widgets: React.FC<{ selectedOrg: string }> = ({ selectedOrg }): JSX.Element => {
  const history: any = useHistory();
  const match: any = useRouteMatch();
  const location: any = useLocation();
  const [selectedTab, setSelectedTab] = useState("widgets");
  const [widgets, setWidgets] = useState<Widget[]>([]);

  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const { SuccessToast, ErrorToast } = useToast()
  const orgDetails = useSelector((state: AppState) => state.org.selectedOrg)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const pathname = location.pathname;
  const hideTabs = pathname.includes("widgetPreview") || pathname.endsWith("createWidget") || pathname.includes("edit");
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  var canViewWidgets = (orgPermissions.includes('marketplace.PublishWidget') && orgPermissions.includes('org.View')) ||  loggedInUserId==orgDetails?.owner;
  const tabs = [
    { name: "Widgets", path: "widgets" },
    { name: "My Widgets", path: "myWidgets" },
    { name: "Installed Widgets", path: "installedWidgets" },
  ];

  const handleRouteNavigation = (path: string) => {
    let pushPath = match.url;

    if (path !== "widgets") {
      pushPath += "/" + path;
    }

    history.push(pushPath);
  };

  useEffect(() => {
    if(!canViewWidgets){
      return
    }
    try {
      Http.get(`/orgs/${orgId}/store/products?type=widget`).subscribe((res: any) => {
        const resp = res.map((widget: Widget) => widget);
        if (res) {
          setWidgets(resp);
        }
      }, (e) => {
        if (e === "Forbidden") {
          canViewWidgets = false
        }
      });
    } catch (e) {
      logger.error(e)
    }
  }, [orgId]);

  const handleWidgetStatus = (widgetId: string, status: boolean) => {
    const updatedWidgets = widgets.map((widget) =>
      widget.id === widgetId ? { ...widget, is_installed: status } : widget
    );
    setWidgets(updatedWidgets);
  }

  const deleteproduct = (id: string) => {
    Http.delete(`/orgs/${orgId}/store/products/${id}`).subscribe((res) => {
      SuccessToast("successfully deleted")
      const filteredWidget = widgets.filter((widget) => {
        return widget.id !== id;
      })
      setWidgets(filteredWidget)
    }, (e) => {
      logger.error(e)
      ErrorToast(e.message)
    });
  }

  return (
    <div className="widgets">
  { canViewWidgets ? <>
      {!hideTabs && <div className="header">
        <div className="left tabs">
          {tabs.map((tab) => (
            <p
              data-test-id={`${tab.name}`}
              key={tab.path}
              className={`tab ${selectedTab === tab.path ? "active" : ""}`}
              onClick={() => handleRouteNavigation(tab.path)}
            >
              {tab.name}
            </p>
          ))}
        </div>
        <div className="right">
          <SearchIcon width="32px" height="32px" />
          <Filter width="32px" height="32px" />
          <PlusIcon width="28px" height="28px" onClick={() => handleRouteNavigation("createWidget")} />
        </div>
      </div>}

      <Switch>
        {/* <Route path={`${match.url}/widgetPreview/:productId`}>
          <WidgetPreview data={widgets} />
        </Route> */}
        <Route path={`${match.url}/widgetPreview/:productId`}>
          <PreviewSidebar />
        </Route>

        <Route path={`${match.url}/myWidgets`}>
          <WidgetContainer
            data={widgets.filter((el: any) => el.org_id === selectedOrg)}
            setSelectedTab={setSelectedTab}
            deleteproduct={deleteproduct}
            handleWidgetStatus={handleWidgetStatus}
          />
        </Route>

        <Route path={`${match.url}/installedWidgets`}>
          <WidgetContainer
            data={widgets.filter((el: any) => el.is_installed)}
            setSelectedTab={setSelectedTab}
            deleteproduct={deleteproduct}
            handleWidgetStatus={handleWidgetStatus}
          />
        </Route>

        <Route path={`${match.url}/createWidget`}>
          <CreateWidget setWidgets={setWidgets}/>
        </Route>

        <Route path={`${match.url}/edit/:productId`}>
          <CreateWidget />
        </Route>

        <Route exact path={match.url}>
          <WidgetContainer data={widgets} 
            setSelectedTab={setSelectedTab}
            deleteproduct={deleteproduct}
            handleWidgetStatus={handleWidgetStatus}
          />
        </Route>

        <Route component={() => <Redirect to="/404" />} />
      </Switch>
      </> :
        <NoData
          svg={WarningIcon}
          header='Not Authorized'
          content='Please request owner of this organization to provide access'
          noButton={true}
        />
      }
    </div>
  );
}

const mapStateToProps = (state: any) => {
  return {
    selectedOrg: state.org.selectedOrg.id
  };
};

export default connect(mapStateToProps)(Widgets);
